<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Track Shipment</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <p style="margin-top:20px;text-align: left"><v-btn v-on:click="sho1(); activate(1);" :class="[(active_el === 1 ) ? 'active_el' : 'default']" flat>In Progress</v-btn> / <v-btn v-on:click="sho2(); activate(2); " :class="[(active_el === 2 ) ? 'active_el' : 'default']" flat>ETA Changes </v-btn>/ <v-btn v-on:click="sho3(); activate(3); " :class="[(active_el === 3 ) ? 'active_el' : 'default']" flat>Pending</v-btn></p>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    v-show="show1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.fat }}</a></td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                      <td class="text-xs-left">{{ props.item.protein }}</td>
                      <td class="text-xs-left">{{ props.item.iron }}</td>
                      <td class="text-xs-left">{{ props.item.status }}</td>
                    </template>
                  </v-data-table>
                  <v-data-table
                    :headers="headers1"
                    :items="desserts1"
                    class="elevation-1"
                    v-show="show2"
                    style="width:1200px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.fat }}</a></td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                      <td class="text-xs-left">{{ props.item.protein }}</td>
                      <td class="text-xs-left">{{ props.item.iron }}</td>
                      <td class="text-xs-left">{{ props.item.status }}</td>
                      <td class="text-xs-left">{{ props.item.oldeta }}</td>
                      <td class="text-xs-left">{{ props.item.neweta }}</td>
                      <td class="text-xs-left"><a href="">{{ props.item.reason }}</a></td>
                    </template>
                  </v-data-table>
                  <v-data-table
                    :headers="headers2"
                    :items="desserts2"
                    class="elevation-1"
                    v-show="show3"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.fat }}</a></td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                      <td class="text-xs-left">{{ props.item.protein }}</td>
                      <td class="text-xs-left">{{ props.item.updateddetails }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order', value: 'calories' },
        { text: 'Booking No', value: 'fat' },
        { text: 'From (Port of Landing)', value: 'carbs' },
        { text: 'To (Port of Discharge)', value: 'protein' },
        { text: 'Vessel', value: 'iron' },
        { text: 'Cargo, No. of Container, Type', value: 'status' }
      ],
      desserts: [
        {
          no: '1',
          calories: '9856321478',
          fat: 'AME/FF/17081001',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry'
        },
        {
          no: '2',
          calories: '9865321596',
          fat: 'AME/FF/17081003',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry'
        },
        {
          no: '3',
          calories: '984563215',
          fat: 'AME/FF/17081083',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry'
        }
      ],
      headers1: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order', value: 'calories' },
        { text: 'Booking No', value: 'fat' },
        { text: 'From (Port of Landing)', value: 'carbs' },
        { text: 'To (Port of Discharge)', value: 'protein' },
        { text: 'Vessel', value: 'iron' },
        { text: 'Cargo, No. of Container, Type', value: 'status' },
        { text: 'OLD ETA, Type', value: 'oldeta' },
        { text: 'NEW ETA', value: 'neweta' },
        { text: 'Reason', value: 'reason' }
      ],
      desserts1: [
        {
          no: '1',
          calories: '9856321478',
          fat: 'AME/FF/17081001',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry',
          oldeta: 'Sept 24',
          neweta: 'Sept 29',
          reason: 'View Reason'
        },
        {
          no: '2',
          calories: '9865321596',
          fat: 'AME/FF/17081003',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry',
          oldeta: 'Sept 24',
          neweta: 'Sept 29',
          reason: 'View Reason'
        },
        {
          no: '3',
          calories: '984563215',
          fat: 'AME/FF/17081083',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          iron: 'MAERSK SHIVLING',
          status: 'Synthetic Resins, Plastic, 6 * 40 ft High Cube Dry',
          oldeta: 'Sept 24',
          neweta: 'Sept 29',
          reason: 'View Reason'
        }
      ],
      headers2: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order', value: 'calories' },
        { text: 'Booking No', value: 'fat' },
        { text: 'From (Port of Landing)', value: 'carbs' },
        { text: 'To (Port of Discharge)', value: 'protein' },
        { text: 'Updated Details', value: 'updateddetails' }
      ],
      desserts2: [
        {
          no: '1',
          calories: '9856321478',
          fat: 'AME/FF/17081001',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          updateddetails: 'Booking confirmation Being Prepared Expected Shortly'
        },
        {
          no: '2',
          calories: '9865321596',
          fat: 'AME/FF/17081003',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          updateddetails: 'Booking confirmation Being Prepared Expected Shortly'
        },
        {
          no: '3',
          calories: '984563215',
          fat: 'AME/FF/17081083',
          carbs: 'Departing form AI Jubay, Saudi Arabia Aug-28',
          protein: 'Arriving at Pyong Teak Sept 10',
          updateddetails: 'Booking confirmation Being Prepared Expected Shortly'
        }
      ],
      show1: true,
      show2: false,
      show3: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
    },
    trackbookingno () {
      this.$router.push('/Trackbookingno')
    },
    activate (el) {
      this.active_el = el
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.active_el {
  background-color: #00C853;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Wynumtrack.vue